import { Divider } from "../../../../src/lib/components/divider/divider";
import Photos from "../../../../src/articles/annual-report/2020/02-review/02-board-of-ddirectors/photos.tsx";
import * as React from 'react';
export default {
  Divider,
  Photos,
  React
};